module.exports = __webpack_public_path__ + "img/news_ads_mobile_1.0a7a6b7e.png";